<template>
  <div
    id="app"
    class="h-100"
    :class="[skinClasses]"
  >
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
// This will be populated in `beforeCreate` hook
import { $themeColors, $themeBreakpoints, $themeConfig } from '@themeConfig'

import store from '@/store'

const LayoutVertical = () => import('@/layouts/vertical/LayoutVerticalSimple.vue')
const LayoutHorizontal = () => import('@/layouts/horizontal/LayoutHorizontal.vue')
const LayoutFull = () => import('@/layouts/full/LayoutFull.vue')

export default {
  components: {
    // Layouts
    LayoutHorizontal,
    LayoutVertical,
    LayoutFull,
  },
  // ! We can move this computed: layout & contentLayoutType once we get to use Vue 3
  // Currently, router.currentRoute is not reactive and doesn't trigger any change
  computed: {
    layout() {
      if (this.$route.meta.layout === 'full') return 'layout-full'
      return `layout-${this.contentLayoutType}`
    },
    contentLayoutType() {
      return this.$store.state.appConfig.layout.type
    },
    skinClasses() {
      const skin = this.$store.state.appConfig.layout.skin
      if (skin === 'bordered') return 'bordered-layout'
      if (skin === 'semi-dark') return 'semi-dark-layout'
      return null
    },
  },
  beforeCreate() {
    // Set colors in theme
    const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger', 'light', 'dark']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = colors.length; i < len; i++) {
      const cssVar = getComputedStyle(document.documentElement).getPropertyValue(`--${colors[i]}`)
      $themeColors[colors[i]] = cssVar ? cssVar.trim() : ''
    }

    // Set Theme Breakpoints
    const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      const cssVar = getComputedStyle(document.documentElement).getPropertyValue(`--breakpoint-${breakpoints[i]}`)
      $themeBreakpoints[breakpoints[i]] = cssVar ? Number(cssVar.slice(0, -2)) : 0
    }

    // Set RTL
    const { isRTL } = $themeConfig.layout
    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr')
  },
  created() {
    // If skin is dark when initialized => Add class to body
    const skin = this.$store.state.appConfig.layout.skin
    if (skin === 'dark') document.body.classList.add('dark-layout')

    // Set Window Width in store
    store.commit('app/UPDATE_WINDOW_WIDTH', window.innerWidth)
    
    // Simple window resize handler
    this.handleResize = () => {
      store.commit('app/UPDATE_WINDOW_WIDTH', window.innerWidth)
    }
    
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    if (this.handleResize) {
      window.removeEventListener('resize', this.handleResize)
    }
  },
}
</script>
